<template>
	<div id="Main">
		<!-- <van-image width="100%" fit="contain" :src="require('../../assets/images/about/address.png')" /> -->
		<!-- (先纬度，后经度) -->
		<iframe width="100%" style="flex: 1;" src="https://api.map.baidu.com/marker?location=30.560079,104.069969&title=我的位置&content=成都托管中心&output=html&src=webapp.baidu.openAPIdemo&s=1" frameborder="0"></iframe>
		<footerbox></footerbox>
	</div>
</template>
<script>
	import footerbox from '../../components/footer';
	export default {
		components: {
			footerbox,
		},
		data() {
			return {
			}
		},
		methods: {

		},
		mounted() {


		},

	}
</script>

<style lang="scss" scoped>
	#Main {
		font-size: 0;
		height: 100vh;
		display: flex;
		flex-direction: column;
	}
</style>
